import { useState } from "react";
import { pressReleases, aiComments } from "../../../mocks/marketing";

export default function PressPanel() {
  const [pressText, setPressText] = useState("");
  const [distributing, setDistributing] = useState(false);
  const [result, setResult] = useState<{ reach: number; score: string; comments: typeof aiComments } | null>(null);
  const [tab, setTab] = useState<"write" | "history">("write");

  const handleDistribute = () => {
    if (!pressText.trim()) return;
    setDistributing(true);
    setTimeout(() => {
      const len = pressText.length;
      const score = len > 150 ? "A+" : len > 80 ? "B" : "C";
      const reach = score === "A+" ? Math.floor(Math.random() * 100000 + 120000)
        : score === "B" ? Math.floor(Math.random() * 50000 + 40000)
        : Math.floor(Math.random() * 20000 + 5000);
      const shuffled = [...aiComments].sort(() => Math.random() - 0.5).slice(0, 5);
      setResult({ reach, score, comments: shuffled });
      setDistributing(false);
    }, 2200);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Tabs */}
      <div className="flex gap-1 bg-[#252830] rounded-xl p-1 mb-3">
        {[{ key: "write", label: "보도자료 작성" }, { key: "history", label: "배포 이력" }].map((t) => (
          <button key={t.key} onClick={() => setTab(t.key as "write" | "history")}
            className={`flex-1 py-1.5 text-xs rounded-lg cursor-pointer whitespace-nowrap transition-colors ${
              tab === t.key ? "bg-[#1C1F2E] text-[#111111]" : "text-[#8B91A8]"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === "write" ? (
        <div className="flex-1 flex flex-col">
          <p className="text-[#5A5E72] text-[10px] mb-2">보도자료를 작성 후 AI 가상 언론사에 배포하세요. 카피 퀄리티에 따라 도달 범위가 결정됩니다.</p>

          <div className="mb-2">
            <label className="text-[#5A5E72] text-[10px] block mb-1">보도자료 제목</label>
            <input placeholder="예: 루나&스타즈 1st EP 발매 공식 입장" maxLength={100}
              className="w-full bg-[#252830] text-white text-xs rounded-lg px-3 py-2 outline-none placeholder-[#5A5E72] border border-transparent focus:border-[#E8375F]/40" />
          </div>

          <div className="flex-1">
            <label className="text-[#5A5E72] text-[10px] block mb-1">본문</label>
            <textarea value={pressText} onChange={(e) => { setPressText(e.target.value); setResult(null); }}
              placeholder="보도자료 본문을 작성하세요. 구체적인 내용과 인용구가 포함될수록 높은 점수를 받습니다..."
              maxLength={500}
              className="w-full bg-[#252830] text-white text-xs rounded-lg px-3 py-2 outline-none placeholder-[#5A5E72] border border-transparent focus:border-[#E8375F]/40 resize-none"
              style={{ height: "100px" }}
            />
            <div className="text-[#5A5E72] text-[10px] text-right">{pressText.length}/500</div>
          </div>

          <div className="mt-2">
            <label className="text-[#5A5E72] text-[10px] block mb-1">배포 대상 언론사</label>
            <div className="flex gap-1.5 flex-wrap">
              {["연합뉴스", "스포츠조선", "아이돌차트", "뮤직뱅크", "스타뉴스"].map((m) => (
                <span key={m} className="text-[10px] bg-[#252830] text-[#8B91A8] px-2 py-0.5 rounded-full cursor-pointer hover:bg-[#E8375F]/10 hover:text-[#E8375F]">{m}</span>
              ))}
            </div>
          </div>

          <button onClick={handleDistribute} disabled={!pressText.trim() || distributing}
            className="w-full mt-3 py-2 bg-[#E8375F] hover:bg-[#d42e52] text-white text-xs rounded-xl disabled:opacity-40 cursor-pointer whitespace-nowrap transition-colors">
            {distributing
              ? <span><i className="ri-loader-4-line animate-spin mr-1"></i>AI 언론사 배포 중...</span>
              : <span><i className="ri-send-plane-line mr-1"></i>배포하기</span>}
          </button>

          {result && (
            <div className="mt-3 space-y-2">
              <div className={`p-3 rounded-xl border text-xs ${
                result.score === "A+" ? "bg-[#00C896]/10 border-[#00C896]/30" : result.score === "B" ? "bg-[#FF9F43]/10 border-[#FF9F43]/30" : "bg-[#E8375F]/10 border-[#E8375F]/30"
              }`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className={`font-bold text-sm ${result.score === "A+" ? "text-[#00C896]" : result.score === "B" ? "text-[#FF9F43]" : "text-[#E8375F]"}`}>
                    {result.score}
                  </span>
                  <span className="text-[#8B91A8]">예상 도달 범위: <b className="text-[#111111]">{result.reach.toLocaleString()}명</b></span>
                </div>
              </div>
              <div>
                <p className="text-[#5A5E72] text-[10px] mb-1.5">AI 댓글 반응 미리보기</p>
                <div className="space-y-1">
                  {result.comments.map((c, i) => (
                    <div key={i} className={`flex items-start gap-1.5 px-2.5 py-1.5 rounded-lg text-[11px] ${
                      c.type === "positive" ? "bg-[#00C896]/5 text-[#C0C4D6]" : c.type === "negative" ? "bg-[#E8375F]/5 text-[#C0C4D6]" : "bg-[#252830] text-[#8B91A8]"
                    }`}>
                      <i className={`${c.type === "positive" ? "ri-heart-3-fill text-[#E8375F]" : c.type === "negative" ? "ri-thumb-down-line text-[#8B91A8]" : "ri-chat-1-line text-[#5A5E72]"} text-xs shrink-0 mt-0.5`}></i>
                      <span className="leading-relaxed">{c.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex-1 overflow-y-auto space-y-2">
          {pressReleases.map((pr) => (
            <div key={pr.id} className="bg-[#252830] rounded-xl p-3">
              <div className="flex items-start justify-between mb-1.5">
                <p className="text-[#111111] text-xs font-medium leading-snug">{pr.title}</p>
                <span className="text-[10px] text-[#00C896] bg-[#00C896]/10 px-2 py-0.5 rounded-full shrink-0 ml-2">{pr.status}</span>
              </div>
              <div className="flex flex-wrap gap-1 mb-1.5">
                {pr.media.map((m) => <span key={m} className="text-[9px] text-[#5A5E72] bg-[#1C1F2E] px-1.5 py-0.5 rounded">{m}</span>)}
              </div>
              <div className="flex items-center justify-between text-[10px] text-[#5A5E72]">
                <span>{pr.date}</span>
                <span className="text-[#FF9F43]"><i className="ri-eye-line mr-0.5"></i>{pr.reach.toLocaleString()} 도달</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
